import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchRemarks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/remarks", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchRemark(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/remarks/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editRemark(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/remarks", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteRemark(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/remarks", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
